<template>
  <modal-center ref="modal" name="speed-assistant">
    <template v-slot:content>
      <div class="modal-card speed-assistant">
        <div class="modal-header">
          <div class="h5">Welke snelheid heb je nodig?</div>
        </div>

        <div class="speed-assistance-options">
          <div v-for="speedOption in speedAssistantOptions" class="speed-assistance-option">
            <div class="speed-box">
              <div class="speed-icon">
                <icon :icon="speedOption.icon"/>
              </div>

              <div>
                <div class="speed-label">
                  <strong>{{ speedOption.label }}</strong> ({{ speedOption.speed }} Mb/s)
                </div>

                <div class="speed-description">
                  {{ speedOption.description }}
                </div>
              </div>
            </div>
            <button-no-icon
                type="ghost"
                @click.native="selectSpeed(speedOption.speed)"
                :disabled="comparisonStore.maxSpeed < speedOption.speed"
                :label="`Kies ${speedOption.speed } Mb/s`"
            >
            </button-no-icon>
          </div>
        </div>
      </div>
    </template>
  </modal-center>
</template>

<script setup>
import Icon from 'vue-elements/icon/Icon.vue';
import ModalCenter from '../../../../abstracts/elements/modal/center/modalCenter.vue';
import ButtonNoIcon from '../../../../abstracts/elements/button/no-icon/button-no-icon.vue';
import { useInternetComparisonStore } from '../stores/internetComparison.js';
import { ref } from 'vue';
const comparisonStore = useInternetComparisonStore();
const modal = ref(null);

const speedAssistantOptions = [
  {
    speed: 50,
    label: 'Licht gebruik',
    description: 'Voor kleine huishoudens tot 2 personen. Wanneer je internet vooral gebruikt voor browsen, e-mail en social media',
    icon: 'x-fa-tachometer-slowest',
  },
  {
    speed: 100,
    label: 'Gemiddeld',
    description: 'Voor huishoudens vanaf 2 personen. Wanneer je tegelijkertijd internet gebruikt, streamt of thuiswerkt.',
    icon: 'x-fa-tachometer-average',
  },
  {
    speed: 200,
    label: 'Snel',
    description: 'Voor grote huishoudens (met kinderen). Wanneer iedereen op meerdere apparaten tegelijk online wil zijn, of gamen',
    icon: 'x-fa-tachometer-fast',
  },
];

const selectSpeed = (speed) => {
  comparisonStore.filters.minSpeed = speed;
  modal.value.close();
};
</script>

<style lang="scss">
@use '../../../../abstracts/elements/modal/center/modalCenter';
@use '../../../../abstracts/elements/button/no-icon/button-no-icon';
@use '../../../../assets/scss/_variables/colors'as colors;
@use '../../../../assets/scss/_helpers/display';
@use '../../../../assets/scss/_helpers/breakpoint';
@use '../../../../assets/scss/_helpers/icon';
@use '../../../../assets/scss/_variables/shadows';

.comparison-module .speed-assistant .modal-header {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  position: relative;

}

.speed-assistant.modal-card {
  padding: 8px;
  max-width: 640px;
}

.speed-assistance-options {
  @include display.flex-col-start();

  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid colors.$border-base;
  gap: 24px;

  .speed-assistance-option {
    @include display.flex-col-start();

    @include breakpoint.up(md) {
      @include display.flex-row-between();
    }

    gap: 24px;
    width: 100%;

    .speed-box {
      @include display.flex-row-start();

      gap: 16px;;
    }

    .button-element.no-icon {
      .label {
        white-space: nowrap;
      }
    }
  }
}

</style>
